import React from 'react';

import { DashboardLibraryIntroCard } from '..';
import { PERSONAL_LIBRARY_INTRO_CARD } from '../../../../../../../shared/constants/workspaceOnboarding';

const PersonalLibraryIntroCard = () => {
  return (
    <DashboardLibraryIntroCard
      cardKey={PERSONAL_LIBRARY_INTRO_CARD}
      heading="Personal Library"
      description="Every time you record a new video, you’ll find it here. Only you can edit and manage videos in this library."
    />
  );
};

export default PersonalLibraryIntroCard;
